import { makeNumberSchema, makeStrictNumberSchema } from '../general/number.ts';

const MIN = 1;
const MAX = Number.MAX_SAFE_INTEGER; /* different from api max b/c JS can't represent it w/ number */

const minMessage = `Read buffer must be at least ${MIN.toLocaleString()}`;
const maxMessage = `Read buffer can be at most ${MAX.toLocaleString()}`;
const requiredMessage = `Choose a number from ${MIN.toLocaleString()} to ${MAX.toLocaleString()}`;

export const listenReadBufferSchema = makeNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
});

export const listenReadBufferRequiredSchema = listenReadBufferSchema.refine((val): val is number => val !== null, {
  message: requiredMessage,
});

export const listenReadBufferStrictSchema = makeStrictNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
  required: { message: requiredMessage },
});
